import type { FC } from 'react';
import React, { createContext, useContext, useState } from 'react';

import type { TAnswer } from '../../models';
import { useQuizContext } from '../quiz';

import type { TQuestion, IQuestionContext, TQuestionStatus } from './models';

const Context = createContext<IQuestionContext>({} as IQuestionContext);

export const useQuestionContext = () => useContext(Context);

/** Вопрос */
export const Question: FC<TQuestion> = ({ children, id, reChoosable = false }) => {
    const { questions, updateQuestions } = useQuizContext();
    const [answer, setAnswer] = useState<TAnswer | undefined>(questions[id]);

    const isAnswered = typeof answer !== 'undefined';
    const isCorrectlyAnswered = isAnswered && answer.isCorrect;

    const status: TQuestionStatus = isAnswered
        ? isCorrectlyAnswered
            ? 'answeredCorrectly'
            : 'answeredWrong'
        : 'notAnswered';

    const toAnswer = (newAnswer: TAnswer) => {
        setAnswer(newAnswer);
        updateQuestions({ [id]: newAnswer });
    };

    return (
        <Context.Provider
            value={{
                answer,
                reChoosable,
                toAnswer,
                status,
            }}
        >
            {children}
        </Context.Provider>
    );
};
